import { AddPrimitivesCommand, AxisT, BasicControl, BlockT, CURSOR_TYPE, DYMODE_MODE, LineT, Listeners, MOUSE, ModelBase, Plane, Point, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode } from "pytha";
import { Vector3 } from "three";
import { ARCHI_CTRL_TYPE } from "../enums/archibase-control-type";
import { getSpecialPrimitiveLayerUuid } from "@/global/utils/layer-utils";

const POINT_TYPE = { POINT_DOWN: 1, POINT_MOVE: 2 };


const STEP = {
    1: { 'tip': '指定基点：', 'mode': DYMODE_MODE.POINT },
    2: { 'tip': 'X轴比例：', 'mode': DYMODE_MODE.NUMBER },
    3: { 'tip': 'Y轴比例：', 'mode': DYMODE_MODE.NUMBER },
    4: { 'tip': 'Z轴比例：', 'mode': DYMODE_MODE.NUMBER },
    5: { 'tip': '绕X轴旋转角度：', 'mode': DYMODE_MODE.ANGLE },
    6: { 'tip': '绕Y轴旋转角度：', 'mode': DYMODE_MODE.ANGLE },
    7: { 'tip': '绕Z轴旋转角度：', 'mode': DYMODE_MODE.ANGLE },
    8: { 'tip': '请输入指令', 'mode': DYMODE_MODE.CHOOSE },
}
export class AddBuildingComponentControl extends BasicControl {

    id = ARCHI_CTRL_TYPE.ADD_BUILDING_COMPONENT

    point_down: Point = new Point();
    point_move: Point = new Point();

    capturePoint: Vector3;

    step: number = 1;

    helpBlock: BlockT;
    blocks: BlockT[];
    helpLine: LineT;

    private _dir = new Vector3();
    private _pointLast = new Point();

    helpBlockAxis: AxisT = new AxisT();;

    axisX: Vector3;
    axisY: Vector3;
    axisZ: Vector3;

    scaleX: number = 1;
    scaleY: number = 1;
    scaleZ: number = 1;

    rotateX: number;
    rotateY: number;
    rotateZ: number;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    angle: number = 0;
    angle_last: number = 0;

    workPlane: Plane = new Plane();
    planeX: Plane = new Plane();
    planeY: Plane = new Plane();
    planeZ: Plane = new Plane();

    /**
     * 当前是否存在辅助坐标系
     */
    axisExist: boolean = false;

    needInit: boolean;

    /**
     * 是否已经插入过块了
     */
    hasInserted: boolean = false;

    type: string = ""

    // layerType: number
    layerUuid: string;
    // projectId: number


    options = {
        0: [
            { name: '退出', key: 'X' },
        ],
        1: [
            { name: '退出', key: 'X' },
        ],
        2: [
            { name: '退出', key: 'X' },
        ],
        3: [
            { name: '退出', key: 'X' },
        ],
        4: [
            { name: '退出', key: 'X' },
        ],
        5: [
            { name: '退出', key: 'X' },
        ],
        6: [
            { name: '退出', key: 'X' },
        ],
        7: [
            { name: '退出', key: 'X' },
        ],
        8: [  //指定插入点后的暂存状态
            { name: '比例', key: 'R' },
            { name: '角度', key: 'A' },
            { name: '退出', key: 'X' }
        ],
    }


    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.editor = editor;
        this.needInit = true;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.listeners.signals.needCapture.dispatch();
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        listeners.signals.setInitControlData.add(this.initControl)

        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        this.editor.selectControl.setEnabled(false);
        this.extraContext.dymodeContext.enabled = true;
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.listeners.signals.sendToDymodeTip.dispatch('指定基点:');
        this.extraContext.stmodeContext.setStmode('指定基点');
        this.axisX = this.context.ucsContext.getAxisList().axisX.clone();
        this.axisY = this.context.ucsContext.getAxisList().axisY.clone();
        this.axisZ = this.context.ucsContext.getAxisList().axisZ.clone();
        this.workPlane.setFromNormalAndCoplanarPoint(this.context.ucsContext.getAxisList().axisZ, this.context.ucsContext.getAxisList().origin);


        console.log('AddBuildingComponentControl added');
    }

    dispose(): void {
        if (!this.hasInserted && this.helpBlock) {
            this.insertBlock();
        }
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.setInitControlData.remove(this.initControl)
        this.editor.selectControl.setEnabled(true);
        if (this.helpLine && this.helpLine.viewObj && this.helpLine.viewObj.parent) {
            this.helpLine.viewObj.parent?.remove(this.helpLine.viewObj);
        }
        if (this.helpBlockAxis && this.helpBlockAxis.viewObj && this.helpBlockAxis.viewObj.parent) {
            this.helpBlockAxis.viewObj.parent?.remove(this.helpBlockAxis.viewObj);
        }
        if (this.helpBlock && this.helpBlock.viewObj && this.helpBlock.viewObj.parent) {
            this.helpBlock.viewObj.parent?.remove(this.helpBlock.viewObj);
        }
        console.log('AddBuildingComponentControl removed');
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    /**
     * 初始化辅助坐标系
     * @param block 
     */
    initHelpAxis = (block: BlockT) => {
        this.axisX.copy(block.axisX);
        this.axisY.copy(new Vector3().crossVectors(block.normal, block.axisX));
        this.axisZ.copy(block.normal);
        this.workPlane.setFromNormalAndCoplanarPoint(this.context.ucsContext.currentUcs.axisZ, this.context.ucsContext.currentUcs.origin);


        if (!this.axisExist) {

            this.helpBlockAxis.origin.copy(block.position);
            this.helpBlockAxis.axisX.copy(this.axisX);
            this.helpBlockAxis.axisY.copy(this.axisY);
            this.helpBlockAxis.axisZ.copy(this.axisZ);
            this.helpBlockAxis.setWorkPlane(this.axisZ);


            this.helpBlockAxis.setValue('origin', block.position);
            this.extraContext.sceneContext.scene.add(this.helpBlockAxis.render());
            this.axisExist = true;
        }
    }


    initControl = (data: { type: string, entities: ModelBase[], position: Point, layerUuid: string }) => {
        if (this.helpBlock && this.helpBlock.viewObj && this.helpBlock.viewObj.parent) {
            this.helpBlock.viewObj.parent?.remove(this.helpBlock.viewObj);
            this.helpBlock.viewObj = null
        }

        let newEntities = []
        for (let i = 0; i < data.entities?.length; i++) {
            newEntities.push(data.entities[i].clone())
        }

        this.type = data?.type || ""
        this.layerUuid = data?.layerUuid;
        // this.helpBlock = new BlockT(data.position, newEntities)
        this.helpBlock = new BlockT(new Point(0, 0, 0), newEntities)
        console.log('this.helpBlock', this.helpBlock)
        this.editor.renderer.domElement.focus();
        this.point_down.set(this.helpBlock.position.x, this.helpBlock.position.y, this.helpBlock.position.z);
        this._pointLast = this.helpBlock.position.clone();
        this.helpBlock.viewObj = null
        let viewObj = this.helpBlock.render();
        this.extraContext.sceneContext.scene.add(viewObj);
        this.initHelpAxis(this.helpBlock);
        this.listeners.signals.needRender.dispatch();
    }

    private _projectPoint = new Point();
    private _extrudePlane = new Plane();
    private _cameraDir = new Vector3();
    private _screenUp = new Vector3();

    /**
     * 该函数用来计算z轴延伸比例
     * @param pointType 
     */
    calculateHeight = (pointType: number) => {
        let point = pointType === POINT_TYPE.POINT_DOWN ? this.point_down : this.point_move;

        const position = this.helpBlock.position;



        let camera = this.editor.camera;
        camera.getWorldDirection(this._cameraDir);
        this._screenUp.copy(camera.up).cross(this._cameraDir).cross(this._cameraDir);
        // 获得光标所在平面，该平面垂直于屏幕，且水平
        this._extrudePlane.setFromNormalAndCoplanarPoint(this._screenUp, point);
        if (Math.abs(this._screenUp.dot(this.axisZ)) < 1e-6) {
            // 平面与拉伸的方向平行，永远没有交点
            this.scaleZ = point.distanceTo(position) / this.helpBlock.scaleLengthZ;
        } else {

            this._extrudePlane.intersectStraightLine(position, this.axisZ, this._projectPoint);
            this.scaleZ = this._projectPoint.sub(position).length() / this.helpBlock.scaleLengthZ;
            if (this._projectPoint.angleTo(this.axisZ) > Math.PI / 2) {
                this.scaleZ *= -1;
            }
        }
        this.helpBlock.setTransValue('scaleZ', this.scaleZ);
        this.helpBlock.updateViewGeometry();
        this.listeners.signals.needRender.dispatch();
        this.extraContext.dymodeContext.setValue('dist', Math.abs(this.scaleZ));
    }

    //TODO  ==============================================================
    //为了修复动态插入块与动态布置设备，设备含有圆柱拉伸体时的边线分离bug
    //产生bug的原因不明，推测与第一次进行图形区的鼠标点位置有关
    //在第一次调用onPointerMove时，将this._dir设置为0， 0， 0即可解决这个问题
    //后面产生问题的原因可能还需要深究
    private firstIn = true;

    onPointerMove = (event) => {
        if (!!!this.helpBlock) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
        // 获取鼠标在当前工作平面上的点
        if (this.step === 4) {
            this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        } else {
            let rect = this.editor.renderer.domElement.getBoundingClientRect();
            let x = (event.clientX - rect.x) / rect.width * 2 - 1;
            let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
            this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_move, this.workPlane);
        }



        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        }

        if (this.step == 1) {
            this._dir.set(this.point_move.x - this.helpBlock.position.x, this.point_move.y - this.helpBlock.position.y, this.point_move.z - this.helpBlock.position.z);
            if (this.firstIn) {
                this._dir.set(0, 0, 0);
                this.firstIn = false;
            }

            this.helpBlockAxis.origin.copy(this.point_move);
            this.helpBlockAxis.updateViewGeometry();


            let length = this._dir.length();
            this._dir.normalize();
            this.helpBlock.move(this._dir, length);
            this.helpBlock.updateViewGeometry();
            this._pointLast.copy(this.point_move);
            this.listeners.signals.needRender.dispatch();

        } else if (this.step == 2) { // x延伸
            const position = this.helpBlock.position;
            this._dir.set(this.point_move.x - position.x, this.point_move.y - position.y, this.point_move.z - position.z).projectOnVector(this.helpBlockAxis.axisX);
            if (this.helpBlock.scaleLengthX > 0) {
                this.scaleX = this._dir.length() / this.helpBlock.scaleLengthX;
                const v = this._dir.dot(this.helpBlockAxis.axisX);
                if (v < 0) {
                    this.scaleX = -this.scaleX;
                }
                this.extraContext.dymodeContext.setValue('number', this.scaleX);
                this.helpBlock.setTransValue('scaleX', this.scaleX);
                this.helpBlock.updateViewGeometry();
                this.listeners.signals.needRender.dispatch();
            }
        } else if (this.step == 3) { // y延伸
            const position = this.helpBlock.position;
            this._dir.set(this.point_move.x - position.x, this.point_move.y - position.y, this.point_move.z - position.z).projectOnVector(this.helpBlockAxis.axisY);
            if (this.helpBlock.scaleLengthY > 0) {
                this.scaleY = this._dir.length() / this.helpBlock.scaleLengthY;
                const v = this._dir.dot(this.helpBlockAxis.axisY);
                if (v < 0) {
                    this.scaleY = -this.scaleY;
                }
                this.extraContext.dymodeContext.setValue('number', this.scaleY);
                this.helpBlock.setTransValue('scaleY', this.scaleY);
                this.helpBlock.updateViewGeometry();
                this.listeners.signals.needRender.dispatch();
            }
        } else if (this.step == 4) { // z延伸
            if (this.helpBlock.scaleLengthZ > 0) {
                this.calculateHeight(POINT_TYPE.POINT_MOVE);
            }
        } else if (this.step == 5) { // x旋转
            const position = this.helpBlock.position;
            this.helpBlockAxis.origin.copy(position);
            this._dir.set(this.point_move.x - position.x, this.point_move.y - position.y, this.point_move.z - position.z);
            this.rotateX = this._dir.angleTo(this.axisY);
            const v = this.axisY.clone().cross(this._dir);
            const n = v.dot(this.axisX);
            if (n < -(1e-6)) {//如果只是写小于0，会出现精度问题导致一直反复旋转
                this.rotateX = 2 * Math.PI - this.rotateX;
            }
            this.extraContext.dymodeContext.setValue('angle', this.rotateX / Math.PI * 180);
            const deltaAngle = this.rotateX - this.angle_last;
            this.angle_last = this.rotateX;
            this.helpBlock.rotate(position.clone(), this.axisX, deltaAngle);
            this.helpBlock.updateViewGeometry();

            this.helpBlockAxis.rotate(position.clone(), this.axisX, deltaAngle);
            this.helpBlockAxis.updateViewGeometry();

            this.helpLine.setValue("end", this.point_move);
            this.helpLine.updateViewGeometry();

            this.listeners.signals.needRender.dispatch();
        } else if (this.step == 6) {
            const position = this.helpBlock.position;
            this.helpBlockAxis.origin.copy(position);
            this._dir.set(this.point_move.x - position.x, this.point_move.y - position.y, this.point_move.z - position.z);
            this.rotateY = this._dir.angleTo(this.axisX);
            const v = this.axisX.clone().cross(this._dir);
            const n = v.dot(this.axisY);
            if (n < -(1e-6)) {//如果只是写小于0，会出现精度问题导致一直反复旋转
                this.rotateY = 2 * Math.PI - this.rotateY;
            }
            this.extraContext.dymodeContext.setValue('angle', this.rotateY / Math.PI * 180);
            const deltaAngle = this.rotateY - this.angle_last;
            this.angle_last = this.rotateY;

            this.helpBlock.rotate(position.clone(), this.axisY, deltaAngle);
            this.helpBlock.updateViewGeometry();

            this.helpBlockAxis.rotate(position.clone(), this.axisY, deltaAngle);
            this.helpBlockAxis.updateViewGeometry();

            this.helpLine.setValue("end", this.point_move);
            this.helpLine.updateViewGeometry();

            this.listeners.signals.needRender.dispatch();
        } else if (this.step == 7) {
            const position = this.helpBlock.position;
            this.helpBlockAxis.origin.copy(position);
            this._dir.set(this.point_move.x - position.x, this.point_move.y - position.y, this.point_move.z - position.z);
            this.rotateZ = this._dir.angleTo(this.axisX);
            const v = this.axisX.clone().cross(this._dir);
            const n = v.dot(this.axisZ);
            if (n < -(1e-6)) {//如果只是写小于0，会出现精度问题导致一直反复旋转
                this.rotateZ = 2 * Math.PI - this.rotateZ;
            }
            this.extraContext.dymodeContext.setValue('angle', this.rotateZ / Math.PI * 180);
            const deltaAngle = this.rotateZ - this.angle_last;
            this.angle_last = this.rotateZ;

            this.helpBlock.rotate(position.clone(), this.axisZ, deltaAngle);
            this.helpBlock.updateViewGeometry();

            this.helpBlockAxis.rotate(position.clone(), this.axisZ, deltaAngle);
            this.helpBlockAxis.updateViewGeometry();

            this.helpLine.setValue("end", this.point_move);
            this.helpLine.updateViewGeometry();
            this.listeners.signals.needRender.dispatch();
        }
    }


    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            if (!this.helpBlock) {
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
                return;
            } else {
                this.insertBlock();
                return;
            }
        }

        if (event.button !== MOUSE.LEFT) return;
        if (!!!this.helpBlock) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }


        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_down, this.workPlane);
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        }
        if (this.step == 1) {
            this.step_1();
        } else if (this.step == 2) {
            this.step_2(this.scaleX);
        } else if (this.step == 3) {
            this.step_3(this.scaleY);
        } else if (this.step == 4) {
            this.step_4(this.scaleZ);
        } else if (this.step == 5) {
            this.step_5();
        } else if (this.step == 6) {
            this.step_6();
        } else if (this.step == 7) {
            this.step_7();
        }
    }

    step_1() {
        this._dir.set(this.point_down.x - this._pointLast.x, this.point_down.y - this._pointLast.y, this.point_down.z - this._pointLast.z);
        let length = this._dir.length();
        this._dir.normalize();
        this.helpBlock.move(this._dir, length);
        this.helpBlock.updateViewGeometry();
        this.helpBlockAxis.origin.copy(this.helpBlock.position);
        this.helpBlockAxis.updateViewGeometry();
        this._pointLast.copy(this.point_move);

        this.workPlane.setFromNormalAndCoplanarPoint(this.helpBlockAxis.axisZ, this.helpBlockAxis.origin);
        this.extraContext.sceneContext.scene.add(this.helpBlockAxis.viewObj);
        this.listeners.signals.needRender.dispatch();
        this.step = 8;
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.dymodeContext.setValue('number', 1);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip, this.options[this.step] || []);
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip);
    }

    step_2(scaleX: number) {
        this.helpBlock.setTransValue('scaleX', scaleX);
        this.helpBlock.updateViewGeometry();
        this.listeners.signals.needRender.dispatch();

        this.step = 3;
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.dymodeContext.setValue('number', 1);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip, this.options[this.step] || []);
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip);
    }

    step_3(scaleY: number) {
        this.helpBlock.setTransValue('scaleY', scaleY);
        this.helpBlock.updateViewGeometry();
        this.listeners.signals.needRender.dispatch();

        this.step = 4;
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.dymodeContext.setValue('number', 1);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip, this.options[this.step] || []);
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip);
    }

    step_4(scaleZ: number) {
        this.helpBlock.setTransValue('scaleZ', scaleZ);
        this.helpBlock.updateViewGeometry();
        this.listeners.signals.needRender.dispatch();
        this.step = 8;
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.dymodeContext.setValue('angle', 0);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip, this.options[this.step] || []);
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip);

        this.planeX.setFromNormalAndCoplanarPoint(this.helpBlockAxis.axisX, this.helpBlockAxis.origin);
        this.workPlane = this.planeX.clone();
    }

    step_5(deltaAngle?: number) {
        const position = this.helpBlock.position;
        if (deltaAngle == null) {
            this._dir.set(this.point_down.x - position.x, this.point_down.y - position.y, this.point_down.z - position.z);
            this.rotateX = this._dir.angleTo(this.helpBlockAxis.axisY);
            const v = this.axisY.clone().cross(this._dir);
            const n = v.dot(this.axisX);
            if (n < 0) {
                this.rotateX = 2 * Math.PI - this.rotateX;
            }
            deltaAngle = this.rotateX - this.angle_last;
        } else {
            // 第一种方法: 计算已经转过的角度，先回正再旋转输入的角度值
            let everRotateAngle = this.axisZ.angleTo(this.helpBlock.normal);
            const v = this.axisZ.clone().cross(this.helpBlock.normal);
            const n = v.dot(this.axisX);
            if (n > 0) {
                deltaAngle = -everRotateAngle + deltaAngle;
            } else {
                deltaAngle = everRotateAngle + deltaAngle;
            }
        }
        this.helpBlock.rotate(position.clone(), this.axisX, deltaAngle);
        this.helpBlock.updateViewGeometry();

        this.helpBlockAxis.rotate(position.clone(), this.axisX, deltaAngle);
        this.helpBlockAxis.updateViewGeometry();

        this.axisX.copy(this.helpBlockAxis.axisX);
        this.axisY.copy(this.helpBlockAxis.axisY);
        this.axisZ.copy(this.helpBlockAxis.axisZ);

        this.listeners.signals.needRender.dispatch();
        this.step = 6;
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.dymodeContext.setValue('angle', 0);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip, this.options[this.step] || []);
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip);

        this.planeY.setFromNormalAndCoplanarPoint(this.helpBlockAxis.axisY, this.helpBlockAxis.origin);
        this.workPlane = this.planeY.clone();
    }

    private _originAxisX: Vector3 = new Vector3(); // 绕Z轴旋转时，块的axisX轴在XY平面上的投影
    step_6(deltaAngle?: number) {
        const position = this.helpBlock.position;
        if (deltaAngle == null) {
            this._dir.set(this.point_down.x - position.x, this.point_down.y - position.y, this.point_down.z - position.z);
            this.rotateY = this._dir.angleTo(this.axisX);
            const v = this.axisX.clone().cross(this._dir);
            const n = v.dot(this.axisY);
            if (n < 0) {
                this.rotateY = 2 * Math.PI - this.rotateY;
            }
            deltaAngle = this.rotateY - this.angle_last;
        } else {
            let everRotateAngle = this.axisX.angleTo(this.helpBlock.axisX);
            const v = this.axisX.clone().cross(this.helpBlock.axisX);
            const n = v.dot(this.axisY);
            if (n > 0) {
                deltaAngle = -everRotateAngle + deltaAngle;
            } else {
                deltaAngle = everRotateAngle + deltaAngle;
            }
        }
        this.helpBlock.rotate(position.clone(), this.axisY, deltaAngle);
        this.helpBlock.updateViewGeometry();


        this.helpBlockAxis.rotate(position.clone(), this.axisY, deltaAngle);
        this.helpBlockAxis.updateViewGeometry();

        this.axisX.copy(this.helpBlockAxis.axisX);
        this.axisY.copy(this.helpBlockAxis.axisY);
        this.axisZ.copy(this.helpBlockAxis.axisZ);

        this.listeners.signals.needRender.dispatch();

        this.step = 7;
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.dymodeContext.setValue('angle', 0);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip, this.options[this.step] || []);
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip);

        this.planeZ.setFromNormalAndCoplanarPoint(this.axisZ, this.helpBlockAxis.origin);
        this.workPlane = this.planeZ.clone();

        this._originAxisX = this.helpBlock.axisX.clone().projectOnPlane(this.axisZ);
    }

    step_7(deltaAngle?: number) {
        const position = this.helpBlock.position;
        if (deltaAngle == null) {
            this._dir.set(this.point_down.x - position.x, this.point_down.y - position.y, this.point_down.z - position.z);
            this.rotateZ = this._dir.angleTo(this.axisX);
            const v = this.axisX.clone().cross(this._dir);
            const n = v.dot(this.axisZ);
            if (n < 0) {
                this.rotateZ = 2 * Math.PI - this.rotateZ;
            }
            deltaAngle = this.rotateZ - this.angle_last;
        } else {
            let everRotateAngle = this._originAxisX.angleTo(this.helpBlock.axisX.clone().projectOnPlane(this.axisZ));
            const v = this._originAxisX.clone().cross(this.helpBlock.axisX.clone().projectOnPlane(this.axisZ));
            const n = v.dot(this.axisZ);
            if (n > 0) {
                deltaAngle = -everRotateAngle + deltaAngle;
            } else {
                deltaAngle = everRotateAngle + deltaAngle;
            }
        }
        this.helpBlock.rotate(position.clone(), this.axisZ, deltaAngle);
        this.helpBlock.updateViewGeometry();

        this.helpBlockAxis.rotate(position.clone(), this.axisZ, deltaAngle);
        this.helpBlockAxis.updateViewGeometry();

        this.axisX.copy(this.helpBlockAxis.axisX);
        this.axisY.copy(this.helpBlockAxis.axisY);
        this.axisZ.copy(this.helpBlockAxis.axisZ);


        this.listeners.signals.needRender.dispatch();


        this.step = 8;
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip, this.options[this.step] || []);
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip);
        if (this.helpLine && this.helpLine.viewObj && this.helpLine.viewObj.parent) {
            this.helpLine.viewObj.parent.remove(this.helpLine.viewObj);
        }
    }

    insertBlock = () => {
        let addBlock = this.helpBlock.clone()
        addBlock.isColorByLayer = false
        addBlock.extraData = {
            type: this.type
        }
        addBlock.getEntities().forEach(item => {
            item.isColorByLayer = false
        })
        if (this.layerUuid) {
            addBlock.layerUuid = this.layerUuid;
        }
        this.editor.history.execute(new AddPrimitivesCommand([addBlock]));
        this.hasInserted = true;
    }

    initHelpLine = () => {
        this.helpLine = new LineT(this.helpBlock.position, this.point_move);
        this.helpLine._isHelpLine = true;
        this.helpLine.color.set('#969c9a');
        this.helpLine.render();
        this.extraContext.sceneContext.scene.add(this.helpLine.viewObj);
    }

    onDymodeChanged = (value: dymode) => {
        if (this.step == 1) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.POINT) {
                this.point_down.set(value.x, value.y, value.z);
                this.step_1();
            }
        } else if (this.step == 2) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.insertBlock();
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.NUMBER) {
                this.scaleX = value.number;
                this.step_2(this.scaleX);
            }
        } else if (this.step == 3) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.insertBlock();
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.NUMBER) {
                this.scaleY = value.number;
                this.step_3(this.scaleY);
            }
        } else if (this.step == 4) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.insertBlock();
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.NUMBER) {
                this.scaleZ = value.number;
                this.step_4(this.scaleZ);
            }
        } else if (this.step == 5) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.insertBlock();
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.ANGLE) {
                this.rotateX = value.angle / 180 * Math.PI;
                this.step_5(this.rotateX);
            }
        } else if (this.step == 6) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.insertBlock();
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.ANGLE) {
                this.rotateY = value.angle / 180 * Math.PI;
                this.step_6(this.rotateY);
            }
        } else if (this.step == 7) {
            if (value.mode === DYMODE_MODE.CHOOSE) {
                if (value.choose === 'X') {
                    //退出
                    this.insertBlock();
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            } else if (value.mode === DYMODE_MODE.ANGLE) {
                this.rotateZ = value.angle / 180 * Math.PI;
                this.step_7(this.rotateZ);
            }
        } else if (this.step === 8) {
            if (value.mode === DYMODE_MODE.CHOOSE) {

                if (value.choose === 'R') {
                    //切换为拉伸比例的模式
                    if (this.helpLine && this.helpLine.viewObj && this.helpLine.viewObj.parent) {
                        this.helpLine.viewObj.parent.remove(this.helpLine.viewObj);
                    }
                    this.step = 2;
                    this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
                    this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
                    this.extraContext.dymodeContext.setValue('number', 0);

                } else if (value.choose === 'A') {
                    //切换为角度模式
                    if (!this.helpLine) {
                        this.initHelpLine();
                    }

                    this.step = 5;
                    this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
                    this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
                } else if (value.choose === 'X') {
                    //退出
                    this.insertBlock();
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                }
            }
        }

    }

    onKeyMouseConfirm = () => {
        if (this.step == 1) {
            this.step_1();
        } else if (this.step == 2) {
            this.scaleX = 1;
            this.step_2(this.scaleX);
        } else if (this.step == 3) {
            this.scaleY = 1;
            this.step_3(this.scaleY);
        } else if (this.step == 4) {
            this.scaleZ = 1;
            this.step_4(this.scaleZ);
        } else if (this.step == 5) {
            this.rotateX = 0;
            this.step_5(this.rotateX);
        } else if (this.step == 6) {
            this.rotateY = 0;
            this.step_6(this.rotateY);
        } else if (this.step == 7) {
            this.rotateZ = 0;
            this.step_7(this.rotateZ);
        } else if (this.step === 8) {
            this.insertBlock();
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
    }

}